import { render, staticRenderFns } from "./EditBannerComponent.vue?vue&type=template&id=42a51396&scoped=true"
import script from "./EditBannerComponent.vue?vue&type=script&lang=js"
export * from "./EditBannerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a51396",
  null
  
)

export default component.exports